import { ColumnType } from 'antd/es/table';
import { TFunction } from 'react-i18next';
import { CountryWithCalendarsDTO } from 'entities/calendar';
import { CountryFlagWithName } from 'entities/country';

export const getColumns = (t: TFunction): ColumnType<CountryWithCalendarsDTO>[] => [
  {
    title: t('calendarsTable.header.country'),
    dataIndex: 'country',
    render: (country, record) => {
      if (record.id === 'loading') return country.englishName;
      return <CountryFlagWithName name={record.name} flagUrl={record.flagUrl} />;
    },
  },
  {
    title: t('calendarsTable.header.calendars'),
    dataIndex: 'calendarsCount',
    render: (calendarsCount, record) => {
      if (record.id === 'loading') return calendarsCount;
      return record.calendars.length;
    },
  },
  {
    title: t('calendarsTable.header.nonWorking'),
    dataIndex: 'nonWorkingDays',
  },
  {
    title: t('calendarsTable.header.working'),
    dataIndex: 'workingDays',
  },
];

export const TOTAL_WIDTH = 800;

export const HEADER_HEIGHT = 39;
export const BORDER_WIDTH = 2;

export const HEIGHT_THRESHOLD = 200;
export const SEARCH_QUERY_LENGTH = 2;
